module.exports = __webpack_public_path__ + "static/img/bgscreenimg1.818f8b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscreenimg1.png
// module id = y+bc
// module chunks = 5